import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField,
  MenuItem, Stack,
} from '@mui/material';
import { HydrantBod, CreateHydrantRequest } from '../../api/JsdhNotifikaceService/generated/models/HydrantBod';

interface Props {
  open: boolean;
  hydrant?: HydrantBod | null;
  onClose: () => void;
  onSubmit: (data: CreateHydrantRequest) => void;
}

const PRAZDNY: CreateHydrantRequest = { oznaceni: '' };

const HydrantFormDialog: React.FC<Props> = ({ open, hydrant, onClose, onSubmit }) => {
  const [form, setForm] = useState<CreateHydrantRequest>(PRAZDNY);

  useEffect(() => {
    if (hydrant) {
      setForm({
        oznaceni: hydrant.oznaceni, typ: hydrant.typ ?? '', dn: hydrant.dn ?? undefined,
        ulice: hydrant.ulice ?? '', popisUmisteni: hydrant.popisUmisteni ?? '',
        lat: hydrant.lat ?? undefined, lng: hydrant.lng ?? undefined,
        rokInstalace: hydrant.rokInstalace ?? undefined, vlastnik: hydrant.vlastnik ?? '',
        poznamka: hydrant.poznamka ?? '',
      });
    } else {
      setForm(PRAZDNY);
    }
  }, [hydrant, open]);

  const set = (k: keyof CreateHydrantRequest) => (e: React.ChangeEvent<HTMLInputElement>) =>
    setForm((f) => ({ ...f, [k]: e.target.value }));

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{hydrant ? 'Upravit hydrant' : 'Nový hydrant'}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField label="Označení" required value={form.oznaceni} onChange={set('oznaceni')} />
          <TextField select label="Typ" value={form.typ ?? ''} onChange={set('typ')}>
            <MenuItem value="">—</MenuItem>
            <MenuItem value="NADZEMNI">Nadzemní</MenuItem>
            <MenuItem value="PODZEMNI">Podzemní</MenuItem>
            <MenuItem value="NASTENNI">Nástěnný</MenuItem>
          </TextField>
          <TextField label="DN" type="number" value={form.dn ?? ''} onChange={set('dn')} />
          <TextField label="Ulice" value={form.ulice ?? ''} onChange={set('ulice')} />
          <TextField label="Popis umístění" value={form.popisUmisteni ?? ''} onChange={set('popisUmisteni')} />
          <Stack direction="row" spacing={2}>
            <TextField label="Lat" type="number" value={form.lat ?? ''} onChange={set('lat')} />
            <TextField label="Lng" type="number" value={form.lng ?? ''} onChange={set('lng')} />
          </Stack>
          <TextField label="Vlastník" value={form.vlastnik ?? ''} onChange={set('vlastnik')} />
          <TextField label="Poznámka" multiline value={form.poznamka ?? ''} onChange={set('poznamka')} />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Zrušit</Button>
        <Button variant="contained" disabled={!form.oznaceni}
          onClick={() => onSubmit({
            ...form,
            dn: form.dn ? Number(form.dn) : undefined,
            lat: form.lat ? Number(form.lat) : undefined,
            lng: form.lng ? Number(form.lng) : undefined,
            rokInstalace: form.rokInstalace ? Number(form.rokInstalace) : undefined,
          })}>Uložit</Button>
      </DialogActions>
    </Dialog>
  );
};

export default HydrantFormDialog;
